<div
  class="rfq-body-content"
  [ngClass]="
    showTopBookOnly
      ? 'rfq-body-content--top-only'
      : 'rfq-body-content--full-height'
  "
>
  <ng-container *ngTemplateOutlet="controlPanel"></ng-container>
  <ng-container *ngTemplateOutlet="mainbody"></ng-container>
  <ng-container *ngTemplateOutlet="footer"></ng-container>
</div>

<!-- END OF MAIN CONTENT -->
<ng-container *ngTemplateOutlet="notTradingReasonTmpl"> </ng-container>

<app-warning-screen
  *ngIf="warningScreenData.warningScreenOpen"
  [isModalOpened]="warningScreenData.warningScreenOpen"
  [headerMessage]="warningScreenData.headerMessage"
  [messageToDisplay]="warningScreenData.messageToDisplay"
  [yesNoOptions]="false"
  (communicate)="warningScreenResponse()"
  (warningOpenChanged)="warningOpenChanged($event)"
></app-warning-screen>

<ui-modal modalTitle="Description" size="md" #modal>
  <app-leg-description
    [legDescription]="selectedQuoteLegDescription"
    [parentModal]="modal"
  ></app-leg-description>
</ui-modal>

<!-- TEMPLATES -->

<!-- MAIN BODY -->
<ng-template #mainbody>
  <div class="main-body scrollable-content">
    <div class="table-divider" id="table-divider" *ngIf="!oneWay"></div>

    <div
      #tableContainer
      class="table-container scrollable-content"
      [ngClass]="{ 'table-container--top-of-book': showTopBookOnly }"
    >
      <div
        class="table-column"
        [ngClass]="{
          hide: oneWay && 'offer' === sideToShow,
          'table-column--bid-only': oneWay && 'bid' === sideToShow
        }"
        [@.disabled]="!animateQuotes"
      >
        <ng-container
          *ngTemplateOutlet="
            indicativePricesTmpl;
            context: { position: 'left', side: 'bid' }
          "
        ></ng-container>

        <ng-container *ngTemplateOutlet="bidQuotes"></ng-container>
      </div>

      @if (
        midPriceInfo &&
        (midPriceInfo.premiumInPercent || midPriceInfo.pips) &&
        (quotes.bids | quoteTimeLimitFilter: currentTimestamp).length &&
        (quotes.offers | quoteTimeLimitFilter: currentTimestamp).length
      ) {
        <div class="mid-price">
          <span class="mid-price__title">MID PRICE</span>
          <span
            >{{
              midPriceInfo.premiumInPercent | abs | percent: '1.4-4'
            }}&nbsp;/&nbsp;{{ midPriceInfo.pips | abs | number: '1.2-2' }}
            @if (midPriceInfo.pips) {
              pips
            }
          </span>
          <span class="mid-price__vols">
            @if (midPriceInfo.vols?.length > 0) {
              @if (midPriceInfo.vols?.length > 2) {
                <ng-container
                  *ngTemplateOutlet="
                    midVolsTooltip;
                    context: { vols: midPriceInfo.vols }
                  "
                ></ng-container>
              }

              <span class="mid-price__vols__prefix"> Vol. </span>
              @for (vol of midPriceInfo.vols; track $index) {
                @if ($index < 2) {
                  <span class="mid-price__vols__values">
                    @if (!$first) {
                      <span class="mid-price__vols__values__delimiter">
                        /
                      </span>
                    }
                    {{ midPriceInfo.vols[$index].toFixed(3) }}%
                  </span>
                } @else if ($index === 2) {
                  /&hellip;
                }
              }
            }
          </span>
          <span class="mid-price__amount">
            {{ midPriceInfo.premiumAmountMid | number: '1.2-2' }}&nbsp;
            {{ midPriceInfo.currency }}
          </span>
          <span class="mid-price__amount" *ngIf="midPriceInfo.spotMid">
            Spot {{ midPriceInfo.spotMid }}
          </span>
        </div>
      }

      <div
        class="table-column"
        [ngClass]="{
          hide: oneWay && 'bid' === sideToShow,
          'table-column--ask-only': oneWay && 'offer' === sideToShow
        }"
        [@.disabled]="!animateQuotes"
      >
        <ng-container
          *ngTemplateOutlet="
            indicativePricesTmpl;
            context: { position: 'right', side: 'offer' }
          "
        ></ng-container>
        <ng-container *ngTemplateOutlet="offerQuotes"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #midVolsTooltip let-vols="vols">
  <clr-tooltip>
    <span clrTooltipTrigger>
      <cds-icon shape="info-circle"></cds-icon>
      <clr-tooltip-content [clrPosition]="'right'" [clrSize]="'md'">
        Vols:
        @for (vol of vols; track $index) {
          {{ vol.toFixed(3) }}%
        }
      </clr-tooltip-content>
    </span>
  </clr-tooltip>
</ng-template>

<!-- BIDQUOTES (LEFT)-->
<ng-template #bidQuotes>
  <div
    #bidTableRowContainer
    class="table-row-container"
    *ngFor="
      let row of quotes.bids | quoteTimeLimitFilter: currentTimestamp;
      index as i;
      trackBy: quoteChanged
    "
    [hidden]="showTopBookOnly && i !== 0"
  >
    <ng-container
      *ngTemplateOutlet="
        quoteTmpl;
        context: {
          side: 'bid',
          position: 'left',
          index: i,
          row: row,
          allowQuoteAnimation: animateQuotes
        }
      "
    ></ng-container>
  </div>
</ng-template>

<!-- OFFERQUOTES (ASK, RIGHT)-->
<ng-template #offerQuotes>
  <div
    #offerTableRowContainer
    class="table-row-container"
    *ngFor="
      let row of quotes.offers | quoteTimeLimitFilter: currentTimestamp;
      index as i;
      trackBy: quoteChanged
    "
    [hidden]="showTopBookOnly && i !== 0"
  >
    <ng-container
      *ngTemplateOutlet="
        quoteTmpl;
        context: {
          side: 'offer',
          position: 'right',
          index: i,
          row: row,
          allowQuoteAnimation: animateQuotes
        }
      "
    ></ng-container>
  </div>
</ng-template>

<!-- CONTROL PANEL -->
<ng-template #controlPanel>
  @if (volBased) {
    <clr-accordion>
      <clr-accordion-panel>
        <clr-accordion-title>Comment</clr-accordion-title>
        <clr-accordion-content *clrIfExpanded>
          <textarea
            ngModel
            (ngModelChange)="rfqCommentChanged($event)"
            class="rfq-comment clr-textarea"
            rows="2"
            maxlength="100"
            placeholder="Enter comment (max. 100 chars)"
          ></textarea>
        </clr-accordion-content>
      </clr-accordion-panel>
      <clr-accordion-panel>
        <clr-accordion-title>Cost Analysis</clr-accordion-title>
        <clr-accordion-content *clrIfExpanded>
          <table ui-table>
            <thead>
              <tr>
                <th colspan="2">Market Data</th>
                <th>Delta</th>
              </tr>
            </thead>
            <tbody>
              @for (r of costAnalysisGrid; track $index) {
                <tr>
                  <td>{{ r[0] }}</td>
                  <td>{{ r[1] }}</td>
                  <td>{{ r[2] }}</td>
                </tr>
              } @empty {
                <tr>
                  <td colspan="3">Awaiting data</td>
                </tr>
              }
            </tbody>
          </table>
        </clr-accordion-content>
      </clr-accordion-panel>
    </clr-accordion>
  }

  <div class="control-panel">
    <a
      role="tooltip"
      aria-haspopup="true"
      class="create-rfq-tooltip"
      [ngClass]="{ 'simple-tooltip': !!pricingMessage }"
      [attr.data-tooltip]="pricingMessage"
    >
      <button
        class="send-rfq-button ui-button ui-button--success"
        [disabled]="!canSendRFQFromTmpl()"
        [ngClass]="{
          'send-rfq-button--error': rfqPricingMessages.isError,
          'send-rfq-button--warning': rfqPricingMessages.isWarning
        }"
        (click)="sendRFQ()"
      >
        <span class="button-text">
          <cds-icon shape="check"></cds-icon> RFQ
        </span>
      </button>
    </a>
    <span
      class="control-panel__position"
      *ngIf="
        rfqTabService?.tabData?.positions?.bid != null &&
        (!oneWay || (oneWay && sideToShow === 'bid'))
      "
    >
      {{ rfqTabService.tabData.positions.bid }}
    </span>

    <!--
    Mothballed: might need to resurrect so keep for now
    <button
      class="ui-button ui-button--rounded ui-button--flex primary ui-button--one-way"
      (click)="changeViewMode()"
    >
      <span class="button-text button-text--one-way">
        <cds-icon
          class="angle-double"
          [ngClass]="!oneWay ? 'angle-double--right' : 'angle-double--left'"
          shape="angle-double"
        ></cds-icon>
        <ng-container *ngIf="!oneWay"> One Way </ng-container>

        <ng-container *ngIf="oneWay"> Two Way </ng-container>
      </span>
    </button> -->
    <!-- This keeps the space for the above -->
    <span></span>

    <span
      class="control-panel__position"
      *ngIf="
        rfqTabService?.tabData?.positions?.offer != null &&
        (!oneWay || (oneWay && sideToShow === 'offer'))
      "
    >
      <app-rfq-offer-formatter
        [offerStr]="rfqTabService.tabData.positions.offer"
      ></app-rfq-offer-formatter>
    </span>

    <button
      class="ui-button ui-button--danger"
      (click)="cancelRfq()"
      [disabled]="!canCancelRFQ"
    >
      <span class="button-text">
        <cds-icon shape="times"></cds-icon> Cancel
      </span>
    </button>
  </div>
</ng-template>

<!-- FOOTER -->
<ng-template #footer>
  <div class="footer">
    <div class="footer__copy-quote-and-timer">
      @if (showCopyQuote) {
        <div>
          @switch (copyQuoteState) {
            @case ('COPIED') {
              <button
                class="ui-button ui-button--flex ui-button__header ui-button--success copy-quote"
              >
                Copied!
              </button>
            }
            @case ('ERROR') {
              <button
                class="ui-button ui-button--flex ui-button__header ui-button--danger copy-quote"
              >
                Error
              </button>
            }
            @case ('COPYING') {
              <button
                class="ui-button ui-button--flex ui-button__header ui-button--primary copy-quote"
              >
                <span class="spinner spinner-sm spinner-inverse"></span>
              </button>
            }
            @case ('COPY_TRADE') {
              <button
                title="Copy trade to clipboard"
                class="ui-button ui-button--flex ui-button__header ui-button--primary copy-quote"
                (click)="getTradeRecap()"
              >
                Copy Trade
              </button>
            }
            @default {
              <button
                title="Copy quote to clipboard"
                class="ui-button ui-button--flex ui-button__header ui-button--primary copy-quote"
                (click)="getQuoteDescription()"
                [disabled]="!canCopyQuote"
              >
                Copy Quote
              </button>
            }
          }
        </div>
      }

      <div
        class="rfq-timer"
        *ngIf="!this.rfqRequestActionStatus && mainTimer?.timer$"
        [ngClass]="this.mainTimer?.checkPoint"
      >
        {{ mainTimer?.timer$ | async | secondsToMinutes }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #indicativePricesTmpl let-side="side" let-position="position">
  <span
    *ngIf="indicativeQuotes?.[side]?.loading; else showQuote"
    class="spinner spinner-sm"
  >
  </span>
  <ng-template #showQuote>
    <ng-container *ngIf="indicativeQuotes?.[side]?.quote">
      <ng-container
        *ngTemplateOutlet="
          quoteTmpl;
          context: {
            side: side,
            position: position,
            index: 0,
            row: indicativeQuotes?.[side].quote,
            allowQuoteAnimation: false
          }
        "
      ></ng-container>
    </ng-container> </ng-template
></ng-template>

<!-- QUOTE -->

<ng-template
  #quoteTmpl
  let-side="side"
  let-position="position"
  let-index="index"
  let-row="row"
  let-allowQuoteAnimation="allowQuoteAnimation"
>
  <app-rfq-quote
    class="quote"
    [row]="row"
    [index]="index"
    [position]="position"
    [side]="side"
    [showVolSpreadLine]="showVolSpreadLine"
    [frozenQuote]="!!frozenQuotes"
    [currentTimestamp]="currentTimestamp"
    [showInlineVol]="showInlineVol"
    [showBank]="showBank"
    [rfqRunning]="rfqRunning"
    [showTopBookOnly]="showTopBookOnly"
    [volBased]="volBased"
    [rfqRequestActionStatus]="rfqRequestActionStatus"
    [hedge]="rfqDetailsDTO?.hedge"
    [forwardPointsMultiplier]="forwardPointsMultiplier"
    [cross]="cross"
    [termPair]="termPair"
    [baseCurrency]="quotePair?.base"
    [termCurrency]="quotePair?.term"
    [animateQuotes]="allowQuoteAnimation"
    [indicativePremiumStyle]="indicativePremiumStyle"
    [pipsHighlightedIndices]="pipsHighlightedIndices"
    [useSingleProviderDetailedView]="
      rfqTabData.executionContext.useSingleProviderDetailedView
    "
    [customHedgeAmount]="enableCustomHedgeAmount && customHedgeAmount()"
    [enableCustomHedgeAmount]="enableCustomHedgeAmount"
    [singleProviderDXState]="rfqSetupService.getSingleProviderDXState()"
    [parent]="parent"
    [nonDxExists]="nonDxExists"
    (requestEmitter)="rfeRequest($event)"
    (showDescription)="doShowDescription($event)"
    (ping)="pingOnce()"
  ></app-rfq-quote>
</ng-template>

<ng-template #notTradingReasonTmpl>
  <ui-modal
    class="rfq-outcome"
    [isOpened]="rfqOutcomeModal().showModal"
    [modalTitle]="'Record RFQ Outcome'"
    [clrModalClosable]="false"
    size="m"
  >
    <div class="rfq-outcome__content">
      <div class="rfq-outcome__content__body">
        Reason for not trading:
        <select clrSelect name="rfqOutcomes" class="rfq-outcome-select" #reason>
          <option *ngFor="let reason of rfqOutcomes" [value]="reason">
            {{ reason }}
          </option>
        </select>
      </div>

      <div class="rfq-outcome__content__footer">
        <button
          class="ui-button ui-button__header primary"
          (click)="saveNotTradingReason(reason.value)"
        >
          Save
        </button>
      </div>
    </div>
  </ui-modal>
</ng-template>

<dialog #rfeTimeoutDialog>
  <h4>Trade execution has not been confirmed.</h4>
  <div class="rfe-timeout-dialog--text">
    <p>
      This may be due to a network delay or because the pricing service
      experienced a technical difficulty.
    </p>
    <p>
      If applicable, please check in your booking system if the trade is
      present. If the issue persists, contact your support team for further
      assistance.
    </p>
    @if (currentRfeExternalID) {
      <p>
        Request ID: {{ currentRfeExternalID }}
        <cds-icon
          shape="copy"
          title="Copy ID to clipboard"
          (click)="copyToClipboard(currentRfeExternalID)"
        ></cds-icon>
      </p>
    }
  </div>
  <form method="dialog">
    <button value="cancel" formmethod="dialog">Close</button>
  </form>
</dialog>
